module.exports = __webpack_public_path__ + "img/ALFALogo.d35fde26.png";